<template>
  <div class="top-margin">
    <div v-bind:id=filts.title>
      <div v-for="filter in filterGroup">
        <div class="select-filters uk-text-truncate" @click="handleFilterUpdate(filter.id, filts.title)">
                   <span v-if="filter.selected">
            <span class="uk-text-middle add-pointer"><img :data-src="LRG_CHECKED_BOX" class="lrg-checkbox"
                                                          uk-img></span>
                     <img v-if="filterGroup.title === RESOURCE_TYPE && filter.id !== 'all'"
                          :data-src="resolveIcon(filter.title)" class="activity-icons add-pointer" uk-img>
            <span class="filter-options add-pointer uk-text-bold options-text">{{filter.title}}</span>
          </span>
        <span v-else>
            <span class=" uk-text-middle add-pointer">
              <img :data-src="LRG_UNCHECKED_BOX" class="lrg-checkbox" uk-img>
            </span>
            <img v-if="filterGroup.title === RESOURCE_TYPE && filter.id !== 'all'" :data-src="resolveIcon(filter.title)"
                 class="activity-icons add-pointer" uk-img>
            <span class="filter-options add-pointer options-text">{{filter.title}}</span>
          </span>
        <span v-if="filter.id === ALL_FILTER_ID || filter.id === NONE_FILTER_ID">
            <div class="separator"></div>
          </span>
      </div>
    </div>
  </div>
  <button class="cp-primary-button button-style uk-width-1-1 uk-align-center" @click="done()">{{$t('general.done')}}
  </button>
  </div>
</template>

<script>
    import {mapActions, mapGetters, mapMutations} from 'vuex'
    import iconUtil from '../../../../utils/icon-util'
    import * as event from '../../../../enums/mixpanel-event'
    import * as grades from '../../../../enums/grades'
    import * as subjects from '../../../../enums/subjects'
    import * as contentType from '../../../../enums/content-type'
    import * as misc from '../../../../enums/misc'
    import gradeUtil from '../../../../utils/grade-util'
    import selectedFilters from '../../../../utils/selected-filters-util'
    import mixpanel from '../../../../services/mixpanel'
    import edgate from '../../../../services/smart-edgate'

    export default {
      name: 'Menu',
      props: ['filts'],
      data() {
        return {
          ALL_FILTER_ID: subjects.ALL_SUBJECTS_ID,
          NONE_FILTER_ID: 'none',
          STANDARDS_FILTER_ID: 'Standards',
          STRANDS_FILTER_ID: 'Strands',
          SOCIAL_STUDIES_ID: subjects.SOCIAL_STUDIES_ID,
          SORTING_FILTER_GROUP: 'Sorting',
          LRG_CHECKED_BOX: iconUtil.resolve(misc.LRG_CHECKED),
          LRG_UNCHECKED_BOX: iconUtil.resolve(misc.LRG_UNCHECKED),
          RESOURCE_TYPE: contentType.CONTENT_TYPE_TITLE
        }
      },
      methods: {
        ...mapActions(['updateSelectedFilters', 'setDefaultFilterGroup']),
        ...mapMutations(['updateSorting', 'setStrands', 'setSearchStrands', 'setSelectedSearchStrands', 'setDefaultStrands']),
        done() {
          this.$emit('done')
        },
        handleFilterUpdate(filterId, filterGroup) {
          if (filterGroup === this.SORTING_FILTER_GROUP) {
            this.sorting.items.map(s => {
              s.selected = s.id === filterId
            })
            this.updateSorting(this.sorting)
          }

          if (filterGroup === this.STANDARDS_FILTER_ID) {
            if (filterId === this.NONE_FILTER_ID) {
              this.setDefaultFilterGroup({filters: this.filters, filterGroup: filterGroup})
              this.setSearchStrands(null)
              this.setStrands(null)
            } else {
              this.updateSelectedFilters({filters: this.filters, filterId: filterId, filterGroup: filterGroup})
              this.fetchStrands(filterId, 1)
            }
          }

          if (filterGroup === this.STRANDS_FILTER_ID) {
            if (filterId === this.NONE_FILTER_ID) {
              this.setDefaultStrands()
            } else {
              this.setSelectedSearchStrands(filterId)
            }
          } else {
            if (filterId === this.ALL_FILTER_ID) {
              this.setDefaultFilterGroup({filters: this.filters, filterGroup: filterGroup})
            } else {
              this.updateSelectedFilters({filters: this.filters, filterId: filterId, filterGroup: filterGroup})
            }
          }

          mixpanel.track(event.FILTER_UPDATE, {
            grades: this.resolveGrades(),
            subjects: this.resolveSubjects(),
            contentType: this.resolveContentType(),
            standards: this.resolveStandards(),
            strands: this.resolveStrands()
          })
        },
        resolveIcon(type) {
          switch (type) {
            case contentType.ACTIVITIES:
              return iconUtil.resolve(contentType.ACTIVITY)
            case contentType.LESSONS:
              return iconUtil.resolve(contentType.LESSON)
            case contentType.ASSESSMENTS:
              return iconUtil.resolve(contentType.ASSESSMENT)
            case contentType.TEMPLATES:
              return iconUtil.resolve(contentType.TEMPLATE)
            case contentType.TEACHER_TOOLS:
              return iconUtil.resolve(contentType.TEACHING_TOOL)
          }
        },
        resolveGrades() {
          let selectedGrades = ''
          try {
            let gradeFilters = this.resolveFilter(grades.GRADES_TITLE)
            for (let grade of gradeFilters) {
              selectedGrades = selectedGrades + ' ' + gradeUtil.resolve(grade)
            }
            return selectedGrades
          } catch (err) {
            return null
          }
        },
        resolveSubjects() {
          let selectedSubjects = ''
          try {
            let subjectFilters = this.resolveFilter(subjects.SUBJECTS_TITLE)
            for (let subject of subjectFilters) {
              selectedSubjects = selectedSubjects + ' ' + subject
            }
            return selectedSubjects
          } catch (err) {
            return null
          }
        },
        resolveFilter(filterGroup) {
          let filters = selectedFilters.resolve(this.filters)
          if (filters.find(o => o.filterGroup === filterGroup).selectedFilters.length) {
            return filters.find(o => o.filterGroup === filterGroup).selectedFilters
          } else {
            return null
          }
        },
        resolveStandards() {
          let selectedStandards = ''
          try {
            let standardFilters = this.resolveFilter('Standards')
            standardFilters.map((standard) => {
              if (standard.selected && standard.id !== 'none') {
                selectedStandards = selectedStandards + ' ' + standard.title
              }
            })
            return selectedStandards
          } catch (err) {
            return null
          }
        },
        resolveStrands() {
          let selectedStrands = ''
          try {
            let strandsFilters = this.resolveFilter('Strands')
            strandsFilters.map((strand) => {
              if (strand.selected && strand.id !== 'none') {
                selectedStrands = selectedStrands + ' ' + strand.title
              }
            })
            return selectedStrands
          } catch (err) {
            return null
          }
        },
        resolveContentType() {
          let selectedContentType = ''
          try {
            let contentTypeFilters = this.resolveFilter(contentType.CONTENT_TYPE_TITLE)
            for (let type of contentTypeFilters) {
              selectedContentType = selectedContentType + ' ' + type
            }
            return selectedContentType
          } catch (err) {
            return null
          }
        },
        fetchStrands(id, q) {
          edgate.search(null, null, id, q)
                    .then(response => {
                      let strands = []
                      let noneSelected = {
                        title: this.$t('general.none'),
                        id: 'none',
                        selected: true
                      }
                      strands.push(noneSelected)
                      let json = JSON.parse(response.text)
                      for (let result of json.results) {
                        let strand = {
                          title: result.standard_number,
                          id: result.guid,
                          standard: result.standard_number,
                          description: result.standard_text,
                          selected: false
                        }
                        strands.push(strand)
                      }
                      this.setSearchStrands(strands)
                    })
        }
      },
      computed: {
        ...mapGetters(['filters', 'sorting', 'searchResults']),
        filterGroup() {
          if (this.filts.title === this.SORTING_FILTER_GROUP) {
            return this.sorting.items
          } else if (this.filts.title === this.STRANDS_FILTER_ID) {
            return this.searchResults.strands
          } else {
            return this.filters.find(o => o.title === this.filts.title).items
          }
        }
      }
    }
</script>
<style lang="scss" scoped>
  @import '../../../../../src/styles/colours.scss';

  .activity-icons {
    height: 30px;
    width: 30px;
  }

  .button-style {
    width: 90%;
    height: 48px;
    border-radius: 2px;
    font-size: 20px;
    font-weight: bold;
  }

  .lrg-checkbox {
    height: 29px;
    width: 29px;
  }

  .options-text {
    color: $content-text;
  }

  .select-filters-options-container {
    background-color: white;
    box-shadow: 3px 5px 8px 0 rgba(0, 0, 0, 0.3);
    overflow: auto;
  }

  .top-margin {
    margin-top: 5px;
  }

  .uk-text-truncate {
    color: $content-text;
  }


</style>
